import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ImpostazioniComponent } from './impostazioni';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('usersettings.index', {
            url: '/index',
            views: {
                'userContent': {
                    // templateUrl: './impostazioni.html',
                    template: '<impostazioni></impostazioni>'
                }
            },
            ncyBreadcrumb: {
                label: 'Impostazioni'
            },
            data: {
                authorisationLevel: 1,
                pageTitle: 'Impostazioni'
            }
        }
        );
};

stateConfig.$inject = ['$stateProvider'];

export const ImpotazioniModule: string = ng
    .module('archiSmall.userSettings.impostazioni', [
        'ui.bootstrap',
        uiRouter,
        'ncy-angular-breadcrumb'
    ])
    .component('impostazioni', ImpostazioniComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/usersettings/impostazioni/impostazioni.module.ts